import * as actionTypes from "./actionTypes";
// import { brands } from "../../data";
import { firebase } from "../../firebase/index";
import {
  collections,
  constants,
  documents,
} from "../../firebase/firestoreNameSpaces";
import {
  generateUniqueId,
  uploadImage,
  deleteFileFromUrl,
  sortArrayObjects,
} from "../utility";
const checkBrandExists = (brands, brandname) => {
  let exists = brands.filter((bObj) => bObj.name == brandname.trim())[0];
  if (exists) {
    return true;
  } else {
    return false;
  }
};
export const onPostBrands = (oldBrand, brandArray, brand) => {
  // console.log(oldBrand, brandArray, brand);
  return async (dispatch) => {
    try {
      //#######################################
      if (checkBrandExists(brandArray, brand.name)) {
        return alert("Please Enter different Name");
      }
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brandBtnLoading: true },
      });

      let db = firebase.firestore();
      let id =
        db.collection(collections.K5METADATA).doc().id + generateUniqueId(4);
      brand.id = id;
      let imgUrl = await uploadImage(
        `brands/${id}/${brand.brandImage.name.replaceAll(/\s/g, "")}`,
        brand.brandImage
      );
      brand.imgUrl = imgUrl;
      delete brand["brandImage"];
      await db
        .collection(collections.K5METADATA)
        .doc(documents.BRANDS)
        .set({ [id]: brand }, { merge: true });
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brandBtnLoading: false },
      });
      return alert("Branded Added Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brandBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onEditBrand = (oldBrand, brandArray, brand, isNameAffected) => {
  return async (dispatch) => {
    try {
      //#######################################
      if (checkBrandExists(brandArray, brand.name.trim()) && isNameAffected) {
        return alert("Please Enter different Name");
      }
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brandBtnLoading: true },
      });

      let db = firebase.firestore();
      // let id = db.collection(collections.K5METADATA).doc().id+generateUniqueId(4)
      // brand.id = id;
      let id = brand.id;
      if (brand.brandImage) {
        let prevImgUrl = brandArray.filter((br) => br.id == brand.id)[0].imgUrl;
        await deleteFileFromUrl(prevImgUrl);
        let imgUrl = await uploadImage(
          `brands/${id}/${brand.brandImage.name.replaceAll(/\s/g, "")}`,
          brand.brandImage
        );
        brand.imgUrl = imgUrl;
      }
      delete brand["brandImage"];
      await db
        .collection(collections.K5METADATA)
        .doc(documents.BRANDS)
        .set({ [id]: brand }, { merge: true });
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brandBtnLoading: false },
      });
      return alert("Brande Updated Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brandBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onFetchBrands = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { loading: true },
      });

      let db = firebase.firestore();
      db.collection(collections.K5METADATA)
        .doc(documents.BRANDS)
        .onSnapshot((snapshot) => {
          console.log("On Snapshot Brands");
          let brands = [];
          let data = snapshot.data();
          for (let bkey in data) {
            brands.push(data[bkey]);
          }

          const fetchedBrands = sortArrayObjects(brands, "name");
          dispatch({
            type: actionTypes.BRANDS_CONTROLS,
            payload: { brands: fetchedBrands, loading: false },
          });
        });
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brands: [], loading: false },
      });
      return alert(error);
    }
  };
};

export const onFetchBrandsClient = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { loading: true },
      });

      let db = firebase.firestore();
      let data = (
        await db.collection(collections.K5METADATA).doc(documents.BRANDS).get()
      ).data();

      let brands = [];
      for (let bkey in data) {
        brands.push(data[bkey]);
      }

      const fetchedBrands = sortArrayObjects(brands, "name");
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brands: fetchedBrands, loading: false },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { brands: [], loading: false },
      });
      return alert(error);
    }
  };
};

export const onDeleteBrand = (brand) => {
  return async (dispatch) => {
    let brandId = brand.id;
    let imgUrl = brand.imgUrl;
    dispatch({
      type: actionTypes.BRANDS_CONTROLS,
      payload: { deleteBtnLoading: true },
    });
    try {
      let db = firebase.firestore();
      await deleteFileFromUrl(imgUrl);
      document.getElementById(`chd${brandId}`).click();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.BRANDS)
        .set(
          { [brandId]: firebase.firestore.FieldValue.delete() },
          { merge: true }
        );
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { deleteBtnLoading: false },
      });
      return alert("Brand Deleted Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { deleteBtnLoading: false },
      });
      return alert(error);
    }
  };
};

export const onFetchBrandProducts = (brandId, productType) => {
  return (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { loading: true },
      });
      let db = firebase.firestore();
      let limit = getState().brands.limit;
      db.collection(collections.PRODUCTS)
        .where("brandId", "==", brandId)
        .where("productTypeId", "==", productType)
        .limit(limit)
        .get()
        .then((snapshot) => {
          if (snapshot.size) {
            let products = [];
            snapshot.forEach((doc) => {
              products.push(doc.data());
            });

            let lastDoc = snapshot.docs[snapshot.size - 1];

            dispatch({
              type: actionTypes.BRANDS_CONTROLS,
              payload: {
                loading: false,
                lastDoc: lastDoc,
                leadsexhausted: snapshot.size < limit ? true : false,
                brandProducts: products,
              },
            });
          } else {
            dispatch({
              type: actionTypes.BRANDS_CONTROLS,
              payload: {
                brandProducts: [],
                loading: false,
                leadsexhausted: snapshot.size < limit ? true : false,
              },
            });
          }
        });
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { loading: false, brandProducts: [] },
      });
      return alert(error);
    }
  };
};

export const onLoadMoreBrandProducts = (
  leadsexhausted,
  limit,
  lastDoc,
  brandId,
  productType
) => {
  return (dispatch, getState) => {
    try {
      if (leadsexhausted) {
        // return alert("Leads Exhausted");
        return true;
      }
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { loadMore: true },
      });
      let db = firebase.firestore();

      db.collection(collections.PRODUCTS)
        .where("brandId", "==", brandId)
        .where("productTypeId", "==", productType)
        .startAfter(lastDoc)
        .limit(limit)
        .get()
        .then((snapshot) => {
          if (snapshot.size) {
            let brandProducts = getState().brands.brandProducts;
            snapshot.forEach((doc) => {
              brandProducts.push(doc.data());
            });

            let lastDoc = snapshot.docs[snapshot.size - 1];

            dispatch({
              type: actionTypes.BRANDS_CONTROLS,
              payload: {
                lastDoc: lastDoc,
                leadsexhausted: snapshot.size < limit ? true : false,
                brandProducts: brandProducts,
                loadMore: false,
              },
            });
          } else {
            dispatch({
              type: actionTypes.BRANDS_CONTROLS,
              payload: {
                loadMore: false,
                leadsexhausted: snapshot.size < limit ? true : false,
              },
            });
          }
        });
    } catch (error) {
      dispatch({
        type: actionTypes.BRANDS_CONTROLS,
        payload: { loadMore: false },
      });
      return alert(error);
    }
  };
};
